import React from 'react';
import { FadeIn } from './ui/FadeIn';
const partners = ['Developers', 'Estate Surveyors', 'Property Firms', 'Corporate Relocation Teams'];
export function Partnership() {
  return <section id="partners" className="py-32 bg-zinc-950 border-t border-white/5" data-id="element-133" data-mp="14uhvgq1giwwi">
      <div className="max-w-4xl mx-auto px-6 text-center" data-id="element-134" data-mp="10txypnkspvaw">
        <FadeIn data-id="element-135" data-mp="10rbtvvpahtwd">
          <h2 className="text-3xl md:text-5xl font-display font-medium text-white leading-tight mb-12" data-id="element-136" data-mp="vublhe4ywf23">
            "MUNISVerse operates as a virtual inspection and presentation
            partner, not a replacement for estate firms."
          </h2>
        </FadeIn>

        <FadeIn delay={0.2} data-id="element-137" data-mp="lwfdgv7bu087">
          <p className="text-zinc-500 uppercase tracking-widest text-sm mb-8" data-id="element-138" data-mp="huk1mwrrs4g6">
            We collaborate seamlessly with
          </p>
          <div className="flex flex-wrap justify-center items-center gap-x-12 gap-y-6" data-id="element-139" data-mp="2gag813vug12h">
            {partners.map((partner, index) => <span key={index} className="text-xl md:text-2xl font-display text-zinc-400" data-id="element-140" data-mp="2c9cy0y0h8z96" data-mpi={index}>
                {partner}
              </span>)}
          </div>
        </FadeIn>
      </div>
    </section>;
}